
export class FormulaTotal{

    public readonly value: number;
    public readonly currency: string;

    public constructor(value: number, currency: string) {
        this.value = value;
        this.currency = currency;
    }
}